

const aracTuruOptions = [
    {
        value: "Çekici",
        text: "Çekici"
    },
    {
        value: "Kamyon",
        text: "Kamyon"
    },
    {
        value: "Kamyonet",
        text: "Kamyonet"
    },
    {
        value: "Özel Amaçlı",
        text: "Özel Amaçlı"
    },
    {
        value: "Otomobil",
        text: "Otomobil"
    },
    {
        value: "Minübüs",
        text: "Minübüs"
    },
    {
        value: "Otobüs",
        text: "Otobüs"
    },
    {
        value: "Traktör",
        text: "Traktör"
    },
    {
        value: "Motosiklet",
        text: "Motosiklet"
    },

]

const sigortaTuruOptions = [
    {
        value: "Zorunlu Trafik Sigortası",
        text:"Zorunlu Trafik Sigortası"
    },
    {
        value: "Kasko",
        text:"Kasko"
    },
    {
        value: "Yük Sigortası",
        text:"Yük Sigortası"
    }
]

const IMMDegeriOptions = [
    {
        value: "100 Bin",
        text:"100 Bin"
    },
    {
        value: "500 Bin",
        text:"500 Bin"
    },
    {
        value: "1 Milyon",
        text:"1 Milyon"
    },
    {
        value: "2 Milyon",
        text: "2 Milyon"
    },
    {
        value: "3 Milyon",
        text: "3 Milyon"
    },
    {
        value: "4 Milyon",
        text: "4 Milyon"
    },
    {
        value: "5 Milyon",
        text:"5 Milyon"
    },
    {
        value: "6 Milyon",
        text: "6 Milyon"
    },
    {
        value: "Sınırsız",
        text:"Sınırsız"
    },
    

]


export {aracTuruOptions, sigortaTuruOptions, IMMDegeriOptions}